import React from 'react';
import { Scale } from 'lucide-react';

interface UsFederalRegisterRegionCtaProps {
  onSelectUnitedStates: () => void;
}

export function UsFederalRegisterRegionCta({
  onSelectUnitedStates,
}: UsFederalRegisterRegionCtaProps) {
  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50/80 p-4 text-center dark:border-slate-600 dark:bg-slate-800/40">
      <div className="mx-auto mb-2 flex h-8 w-8 items-center justify-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-950 dark:text-blue-300">
        <Scale className="h-4 w-4" />
      </div>
      <p className="text-sm text-gray-600 dark:text-gray-300">
        To see Federal Register &amp; Executive Orders,{' '}
        <button
          type="button"
          className="font-medium text-blue-700 hover:underline dark:text-blue-300"
          onClick={onSelectUnitedStates}
        >
          switch region to United States
        </button>
        .
      </p>
    </div>
  );
}
